<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <div class="rightBtn">
          <template>
            <WhiteButton
              text="nextengine.nextengine_ec-goods-csv-download"
              height="32px"
              width="210px"
              class="mx-1"
              @click="getEcGoodsCsv"
            />
            <NormalButton
              text="nextengine.nextengine_ec-goods-csv-upload"
              height="32px"
              width="140px"
              class="mx-1"
              @click="triggerFileUpload"
            />
            <input
              ref="file"
              type="file"
              class="fileInput"
              accept=".csv"
              @change="uploadEcGoodsCsv"
            />
          </template>
        </div>
      </template>
      <template #list>
        <div class="description">
          {{ $t('nextengine.nextengine_ec-goods-description') }}
        </div>
        <div class="ecGoodsTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getEcGoodsListFromState()"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.goodsId`]="{ item }">
              <div class="font-weight-bold">{{ item.goodsId || '-' }}</div>
            </template>
            <template #[`item.goodsName`]="{ item }">
              <div class="font-weight-bold">{{ item.goodsName || '-' }}</div>
            </template>
            <template #[`item.goodsSupplierName`]="{ item }">
              <div class="font-weight-bold">
                {{ item.goodsSupplierName || '-' }}
              </div>
            </template>
            <template #[`item.linkedProduct`]="{ item }">
              <div class="font-weight-bold">
                {{ item.linkedProduct.productNumber || '-' }}
              </div>
            </template>
            <template #[`item.linkedProduct`]="{ item }">
              <div class="font-weight-bold">
                {{
                  item.linkedProduct.nameJp + ' ' + item.linkedProduct.nameCn ||
                  '-'
                }}
              </div>
            </template>
            <template #[`item.edit`]="{ item }">
              <WhiteButton
                text="nextengine.nextengine_ec-goods-link"
                height="32px"
                width="72px"
                @click.native="edit(item)"
              />
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <EcGoodsDialog
      v-model="dialogInfo.edit"
      :ecGoodsData="ecGoodsData"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import { EcGoodsDialog } from '@/components/layouts/Dialogs'
import { NormalButton, WhiteButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    Master,
    EcGoodsDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'nextengine.nextengine_ec-goods-list',
      buttonName: 'common.common_csv-upload',
      ecGoodsData: {},
      dialogInfo: {
        edit: false // ダイアログの開閉状態
      },
      headers: headers.headers,
      itemKey: 'ecGoodsId',
      //linkedProductId: null,
      editMode: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  methods: {
    ...mapActions('Nextengine', [
      'getEcGoodsListFromApi',
      'getEcGoodsCsvFromApi',
      'ecGoodsCsvUploadFromApi'
    ]),
    ...mapGetters('Nextengine', ['getEcGoodsListFromState']),
    ...mapActions('Common', ['setIsLoading']),
    async init() {
      this.setIsLoading(true)
      await this.getEcGoodsListFromApi()
      this.setIsLoading(false)
    },
    async getEcGoodsCsv() {
      if (await this.getEcGoodsCsvFromApi()) {
        alert(this.$t('common.common_ledger-sheet-big-data-alert'))
      }
    },
    triggerFileUpload() {
      // this.$refs.fileを通じて非表示のinput要素をクリックさせ、
      // ファイル選択ダイアログを開きます。
      this.$refs.file.click()
    },
    async uploadEcGoodsCsv(event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append('uploadFile', file)
      if (await this.ecGoodsCsvUploadFromApi(formData)) {
        // アップロード成功時、画面リロード
        this.$router.go({ path: this.$router.currentRoute.path, force: true })
      }

      // ファイル選択後に同じファイルを再度選択できるように値をリセットします。
      event.target.value = ''
    },
    edit(ecGoods) {
      this.ecGoodsData = _cloneDeep(ecGoods)
      this.dialogInfo.edit = true
      //this.linkedProductId = 12912// ecGoods.linkedProductId
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    }
  }
}
</script>
<style scoped lang="scss">
.description {
  font-size: 14px;
  padding: 0px 0px 11px 0px;
}
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
.fileInput {
  display: none;
}
.csvSampleStyle {
  width: 88px;
  height: 12px;
  margin: 8px 12px 0px 0px;
  font-size: 12px;
  text-decoration: none;
}
.fileInputLabel {
  width: 108px;
  height: 32px;
  margin: 0px 12px 0px 0px;
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  font-size: 12px;
  color: #6a6a6a;
}
.ecGoodsTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
</style>
